import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, themes, Confirm } from 'libs/ui';
import { Content, ConfirmTitle } from './row-actions.styled';
import { deleteAdv } from 'services/adv-service';
import { notify } from 'libs/common';

export const RowActions = (props) => {
  const { t } = useTranslation();
  const { row, refreshData, onDeleted } = props;
  const [form, setForm] = useState('');

  /**
   * del confirm
   */
  const showDelConfirm = () => {
    setForm('delConfirm');
  };

  /**
   * hide del confirm
   */
  const hideDelConfirm = () => {
    setForm('');
  };

  /**
   * delete adv
   */
  const delAdv = async () => {
    let err = false;
    await deleteAdv(row.original?.id).catch((error) => {
      err = true;
      notify(t('messages.Ошибка удаления файла'), error?.message);
    });

    if (!err) {
      onDeleted();
      refreshData();
    }
  };

  let fn = row.original?.name;
  if (fn.length > 15) {
    fn = fn.substring(0, 15) + '...';
  }

  const confirm = {
    title: (
      <ConfirmTitle>
        {t('grid.Файл')} <b title={row.original?.name}>{fn}</b> {t('messages.будет удален. Продолжить?')}
      </ConfirmTitle>
    ),
    width: '440px',
    type: 'danger',
    cancelButton: { text: t('buttons.Отмена'), func: hideDelConfirm },
    acceptButton: { text: t('buttons.Удалить'), func: delAdv, theme: themes.red },
  };

  return (
    <>
      <Content>
        <Button
          theme={themes.red}
          fontSize={'13px'}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            showDelConfirm();
          }}
        >
          {t('buttons.Удалить')}
        </Button>
      </Content>
      {form === 'delConfirm' && <Confirm {...confirm} />}
    </>
  );
};
